import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import './Terms.css';

const SECTIONS = [
  { id: 'codice-condotta', title: 'Codice di Condotta', file: 'codice-condotta.pdf' },
  {
    id: 'condizioni-juventus-card',
    title: "Condizioni Generali di Vendita e Condizioni d'Uso JUVENTUS CARD 25_26",
    file: 'condizioni-juventus-card.pdf',
  },
  {
    id: 'condizioni-servizi-juventus',
    title: "Condizioni generali d'uso dei Servizi Juventus (1 luglio 2024)",
    file: 'condizioni-servizi-juventus.pdf',
  },
  {
    id: 'regolamento-impianto',
    title: "Regolamento d'uso dell'impianto",
    file: 'regolamento-impianto.pdf',
  },
  {
    id: 'richiesta-striscioni',
    title: 'Richiesta striscioni Allianz Stadium Stagione 2026-27',
    file: 'richiesta-striscioni.pdf',
  },
  {
    id: 'termini-titoli-accesso',
    title:
      "Termini e condizioni d'uso dei titoli di accesso per le singole gare e per pacchetti di gare - Allianz Stadium 2026-2027",
    file: 'termini-titoli-accesso.pdf',
  },
  {
    id: 'termini-membership',
    title: 'Termini e Condizioni - Membership 2026-2027',
    file: 'termini-membership.pdf',
  },
];

const Terms = () => {
  const { t } = useLanguage();
  const baseUrl = `${process.env.PUBLIC_URL || ''}/reglements`;

  return (
    <div className="terms-page">
      <div className="container">
        <h1 className="terms-page-title">{t('terms.title')}</h1>
        <p className="terms-page-intro">
          {t('terms.intro')}
        </p>

        <div className="terms-sections">
          {SECTIONS.map((section) => (
            <section key={section.id} id={section.id} className="terms-section">
              <h2 className="terms-section-title">{section.title}</h2>
              <a
                href={`${baseUrl}/${section.file}`}
                download
                target="_blank"
                rel="noopener noreferrer"
                className="terms-download-link"
              >
                {t('terms.download')}
              </a>
            </section>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Terms;
